import { Component, inject } from '@angular/core';
import { ListViewSettingModel } from '@fi-app/components/items-list/list-view-setting.model';
import { DocumentListData } from '../document-list-data-service';
import { ItemListContainerBase } from '@fi-app/core/item-list-container-base';
import { IDocumentModel } from '../document';
import { FiItemsListHelperService } from '@fi-app/shared/fi-items-list/fi-items-list-helper.service';

@Component({
    selector: 'fi-document-list-container',
    template: `
        <fi-document-list
            [isFavoriteIconShown]="false"
            [isItemActionsShown]="false"
            [allowMultiSelect]="false"
            (selectionChanged)="onSelectionChanged($event)"
        />
        <!-- <fi-document-list-view
            [listData]="ListData"
            [documentListViewSettings]="documentListViewSettings"
        ></fi-document-list-view> -->
    `,
    styleUrls: ['./document-list-container.component.scss'],
    standalone: false,
})
export class DocumentListContainerComponent extends ItemListContainerBase {
    documentListViewSettings: ListViewSettingModel;
    ListData: DocumentListData;

    private itemsListHelperService = inject(FiItemsListHelperService);

    protected onSelectionChanged($event: IDocumentModel[]): void {
        this.itemsListHelperService.triggerExtendedSearchSelectionChanged($event);
    }
}
